import { IoCloseCircleOutline } from "react-icons/io5";

const INPUT_BASE_CLASS =
  "bg-cfTextInputBorder border text-cfGlobalText text-sm rounded-lg focus:ring-cfButton focus:border-cfButton block w-full";
const INPUT_PADDING_CLASS = "p-2";
const INPUT_BORDER_CLASS = "border-cfIssuedScreenSearchBorder";

export default function TagInputSection({
  title,
  inputId,
  addButtonId,
  value,
  onChange,
  onKeyDown,
  onPaste,
  onAdd,
  placeholder,
  items,
  onRemove,
  tagIdPrefix,
  removeIdPrefix,
  emptyText,
  hintText,
  addLabel,
  removeLabel = "Remove",
}) {
  return (
    <div className="flex flex-col h-full">
      <label
        htmlFor={inputId}
        className="block mb-1.5 text-sm font-medium text-cfHeadingText"
      >
        {title}
      </label>
      <div className="flex flex-col flex-1 border border-cfIssuedScreenSearchBorder rounded-lg p-2.5 bg-cfSecondary min-h-[7.5rem]">
        <div className="flex gap-2 mb-2">
          <input
            type="text"
            id={inputId}
            value={value}
            onChange={onChange}
            onKeyDown={onKeyDown}
            onPaste={onPaste}
            placeholder={placeholder}
            className={`${INPUT_BASE_CLASS} ${INPUT_PADDING_CLASS} ${INPUT_BORDER_CLASS} flex-1 min-w-0`}
          />
          <button
            type="button"
            id={addButtonId}
            onClick={onAdd}
            className="bg-cfPrimary rounded-[8px] text-cfSecondary px-3 py-1.5 text-sm font-medium hover:bg-cfPrimaryDark shrink-0"
          >
            {addLabel}
          </button>
        </div>

        <div className="flex-1 min-h-[3rem] max-h-[3rem] overflow-y-auto">
          {items.length > 0 ? (
            <div className="flex flex-wrap gap-1.5">
              {items.map((item, index) => (
                <div
                  key={`${tagIdPrefix}-${item}-${index}`}
                  id={`${tagIdPrefix}-${index}`}
                  className="bg-blue-100 text-blue-800 px-3 py-1 rounded-full flex items-center gap-2 max-w-full"
                >
                  <span className="text-sm truncate">{item}</span>
                  <button
                    type="button"
                    id={`${removeIdPrefix}-${index}`}
                    onClick={() => onRemove(item)}
                    aria-label={`${removeLabel} ${item}`}
                    className="text-blue-600 hover:text-blue-800 shrink-0"
                  >
                    <IoCloseCircleOutline size={18} />
                  </button>
                </div>
              ))}
            </div>
          ) : (
            <p className="text-gray-500 text-sm">{emptyText}</p>
          )}
        </div>

        <p className="text-[11px] text-cfViewAllTagText mt-1.5 leading-tight">
          {hintText}
        </p>
      </div>
    </div>
  );
}
